import { Component, Injector, OnDestroy, OnInit, } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Subscription } from 'rxjs';

import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';
import { SharedService } from '../common/shared.service';
import { ShareUtils } from '../common/shareutils';
import { Utils } from '../common/utils.component';
import { Option } from '../models/option';
import { ShareLink } from '../models/sharelink';
import { ShareSettings } from '../models/sharesettin';

/*
   Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
*/
@Component({
  selector: 'sharesettings-dialog',
  templateUrl: './sharesettings-dialog.component.html'
})
export class ShareSettingsDialogComponent implements OnInit, OnDestroy {

  type: string = "";
  foldertype: string = ""
  types: string;
  isfile: boolean;
  location: string = ""
  id: number = 0;
  name: string = "";
  size: string = "";
  lastmodified: string = "";
  isRestrictedSite: boolean = false;
  loading = true;
  accessible: Option[];
  downloadrights: Option[];
  linkexpires: Option[];

  accessibleByFg: FormGroup;
  downloadRightsFg: FormGroup;
  linkExpiresFg: FormGroup;
  passwordFg: FormGroup;

  accessibleindex: number;
  downloadindex: number;
  linkindex: number;

  isWaterMark: boolean;
  isApproveVersions: boolean;
  notifyEditdownload: boolean;
  isrestrictionchanged: boolean = false;
  shareSettings: ShareSettings = new ShareSettings();
  share = new ShareLink();
  password: string;
  shareRestricted: string = Constants.SHARE_LINK_RESTRICTED_MSG

  passwordFc = new FormControl('', [Validators.maxLength(Constants.MAXPASSWORDCHAR), this.noWhitespaceValidator,Constants.passwordValidator]);
  dialogRef: MatDialogRef<ShareSettingsDialogComponent>;
  data: any;
  subscription: Subscription;
  uploadShareData: any;
  errorMsg = { str: "" }
  sharebutton = { isDisabled: false, sharetitle: Constants.SHARE_LINK, sharetitledefault: Constants.SHARE_LINK }
  hide:boolean=true;
    
  public barLabel: string = Constants.PASSWORD_STRENGTH;  
  
  constructor(private sharedSer: SharedService, private injector: Injector,
    private shareUtils: ShareUtils,
    private apiService: APIService,
    public dialog: MatDialog) {
    this.dialogRef = this.injector.get(MatDialogRef, null);
    this.data = this.injector.get(MAT_DIALOG_DATA, null);
    this.accessibleByFg = new FormGroup({
      accessibleByFc: new FormControl()
    });

    this.downloadRightsFg = new FormGroup({
      downloadRightsFc: new FormControl()
    });

    this.linkExpiresFg = new FormGroup({
      linkExpiresFc: new FormControl()
    });

    this.subscription = this.sharedSer.updateShareData$.subscribe(
      updateShareData => {
        this.uploadShareData = updateShareData
        this.parseDialogData()
      });

  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
    this.sharedSer.updateShareData$.next(null)

  }
  parseDialogData() {
    if (this.uploadShareData != null && this.uploadShareData != undefined && this.uploadShareData.id != undefined) {
      this.type = this.uploadShareData.type;
      this.types = this.uploadShareData.types;
      this.id = this.uploadShareData.id;
      this.location = this.uploadShareData.location;
      this.name = this.uploadShareData.name;
      this.size = this.uploadShareData.size;
      this.lastmodified = this.uploadShareData.lastmodified;
      this.shareSettings = this.uploadShareData.shareSettings;
      this.foldertype = this.uploadShareData.foldertype;
    } else {
      if (this.data != null) {
        this.type = this.data.type;
        this.types = this.data.types;
        this.id = this.data.id;
        this.location = this.data.location;
        this.name = this.data.name;
        this.size = this.data.size;
        this.lastmodified = this.data.lastmodified;
        this.shareSettings = this.data.shareSettings;
        this.foldertype = this.data.foldertype;
      }
    }
    if (this.types == "file")
      this.isfile = true;
    this.setShareSettings(this.shareSettings);
  }

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedSer);
    this.apiService.setTheme();
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    const lengthLess = (control.value || '').trim().length < 5;
    return isValid && !lengthLess ? null : { 'whitespace': true };
  } 

  public getPasswordIcon() {
    if(this.hide)
     return "hide";
    else 
     return "show" 
  }

  getErrorMessage(passwordFc) {
    return this.shareUtils.getErrorMessage(passwordFc);
  }

  setDataFromAPI(share: ShareSettings) {
    if (((this.location.includes('My files') || this.location.includes('My site')) && share.sharevialink.options.option.length == 1) || (share.sitesharevialink == undefined || share.sitesharevialink.options.option[0].alias.length == 0)) {
      var index = this.shareUtils.optionsAccessibleMysite.findIndex(item => item.alias === share.sharevialink.options.option[0].alias);
      this.shareUtils.optionsAccessibleMysite.forEach(item => {
        item.default = false
      });
      this.shareUtils.optionsAccessibleMysite[index].default = true;
      this.accessible = this.shareUtils.optionsAccessibleMysite;
    } else if (share.sitesharevialink.options.option.length == 1) {
      var otherindex = this.shareUtils.optionsAccessibleOthersite.findIndex(item => item.alias === share.sitesharevialink.options.option[0].alias);
      this.shareUtils.optionsAccessibleOthersite[otherindex].default = true;
      this.accessible = this.shareUtils.optionsAccessibleOthersite;
    } else if (this.location.includes('My files') || this.location.includes('My site')) {
      this.accessible = share.sharevialink.options.option;
    } else {
      this.accessible = share.sitesharevialink.options.option;
    }

    if (((this.location.includes('My files') || this.location.includes('My site')) && share.drmsetting.options.option.length == 1) || (share.sitedrmsetting == undefined || share.sitedrmsetting.options.option[0].alias.length == 0)) {
      var indexdrm = this.shareUtils.optionsDrmMysite.findIndex(item => item.alias === share.drmsetting.options.option[0].alias);
      this.shareUtils.optionsDrmMysite.forEach(item => {
        item.default = false
      });
      this.shareUtils.optionsDrmMysite[indexdrm].default = true;
      this.downloadrights = this.shareUtils.optionsDrmMysite;
    } else if (share.sitedrmsetting.options.option.length == 1) {
      var otherindexdrm = this.shareUtils.optionsDrmOthersite.findIndex(item => item.alias === share.sitedrmsetting.options.option[0].alias);
      this.shareUtils.optionsDrmOthersite[otherindexdrm].default = true;
      this.downloadrights = this.shareUtils.optionsDrmOthersite;
    } else if (this.location.includes('My files') || this.location.includes('My site')) {
      this.downloadrights = share.drmsetting.options.option;
    } else {
      this.downloadrights = share.sitedrmsetting.options.option;
    }

    if (share.quicksharelinkexpiry.options.option.length == 1) {
      var indexlink = this.shareUtils.optionsSharelinkexpire.findIndex(item => item.alias === share.quicksharelinkexpiry.options.option[0].alias);
      this.shareUtils.optionsSharelinkexpire[indexlink].default = true;
      this.linkexpires = this.shareUtils.optionsSharelinkexpire;
    } else {
      this.linkexpires = share.quicksharelinkexpiry.options.option;
    }
  }

  public setShareSettings(share: ShareSettings) {
    this.isrestrictionchanged = share.restrictchanged;
    this.setDataFromAPI(share)
    this.setAccessiblebyData(share);
    this.setDownloadRightsData(share);
    this.sharebutton.isDisabled = false;
    this.sharebutton.sharetitle = Constants.SHARE_LINK;
    this.sharebutton.sharetitledefault = Constants.SHARE_LINK;

    if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) == "undefined" || Number(localStorage.getItem(Constants.LINKEXPIRES_STORAGE)) < 0) {
      this.linkExpiresFg.get('linkExpiresFc').setValue(this.linkexpires.find(link => link.default))
      this.linkindex = this.linkexpires.findIndex(item => item.displayname === this.linkExpiresFg.get('linkExpiresFc').value.displayname);
    } else {
      this.linkExpiresFg.get('linkExpiresFc').setValue(this.linkexpires[Number(localStorage.getItem(Constants.LINKEXPIRES_STORAGE))]);
      this.linkindex = this.linkexpires.findIndex(item => item.displayname === this.linkExpiresFg.get('linkExpiresFc').value.displayname);
    }
    this.password = this.shareUtils.getPassword(this.location, share)

    if (localStorage.getItem(Constants.NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE) == '1')
      this.notifyEditdownload = true
    else
      this.notifyEditdownload = false

    this.loading = false;

  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }

  setAccessiblebyData(share) {
    //Set Accessible(Share link) settings for My site
    var accessFiles;
    var sharelinkrestrict;
    if (this.location.includes('My files') || this.location.includes('My site')) {
      accessFiles = Number(localStorage.getItem(Constants.ACCESSIBLEBY_MYFILES_STORAGE))
      sharelinkrestrict = share.sharevialinkrestrict;
    }
    else {
      accessFiles = Number(localStorage.getItem(Constants.ACCESSIBLEBY_OTHERFILES_STORAGE))
      sharelinkrestrict = share.sitesharevialinkrestrict;
    }

    if (accessFiles > 0 && !sharelinkrestrict) {
      this.accessibleByFg.get('accessibleByFc').setValue(this.accessible[accessFiles - 1]);
      this.accessibleindex = this.accessible.findIndex(item => item.displayname === this.accessibleByFg.get('accessibleByFc').value.displayname);
    } else {
      this.accessibleByFg.get('accessibleByFc').setValue(this.accessible.find(access => access.default))
      this.accessibleindex = this.accessible.findIndex(item => item.displayname === this.accessibleByFg.get('accessibleByFc').value.displayname);
    }
    if (sharelinkrestrict) {
      this.accessibleByFg.get('accessibleByFc').disable();
    }
    else {
      this.accessibleByFg.get('accessibleByFc').enable();
    }
  }

  setDownloadRightsData(share) {
    var downloadFiles;
    if (this.location.includes('My files') || this.location.includes('My site'))
      downloadFiles = Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_MYFILES_STORAGE))
    else
      downloadFiles = Number(localStorage.getItem(Constants.DOWNLOADRIGHTS_OTHERFILES_STORAGE))

    //Set DRM settings for site
    if (downloadFiles > 0 && !share.drmsettingrestrict) {
      this.downloadRightsFg.get('downloadRightsFc').setValue(this.downloadrights[downloadFiles - 1]);
      this.downloadindex = this.downloadrights.findIndex(item => item.displayname === this.downloadRightsFg.get('downloadRightsFc').value.displayname);

    } else {
      this.downloadRightsFg.get('downloadRightsFc').setValue(this.downloadrights.find(download => download.default))
      this.downloadindex = this.downloadrights.findIndex(item => item.displayname === this.downloadRightsFg.get('downloadRightsFc').value.displayname);
    }
    if (share.drmsettingrestrict) {
      this.downloadRightsFg.get('downloadRightsFc').disable();
    } else {
      this.downloadRightsFg.get('downloadRightsFc').enable();
    }
    var watermark;
    if (this.location.includes('My files') || this.location.includes('My site'))
      watermark = localStorage.getItem(Constants.WATERMARK_MYFILES_STORAGE)
    else
      watermark = localStorage.getItem(Constants.WATERMARK_OTHERFILES_STORAGE)

    if (watermark == '1')
      this.isWaterMark = true
    else
      this.isWaterMark = false

    var approveNewVersion;
    if (this.location.includes('My files') || this.location.includes('My site'))
      approveNewVersion = localStorage.getItem(Constants.APPROVE_NEW_VERSIONS_MYFILES_STORAGE)
    else
      approveNewVersion = localStorage.getItem(Constants.APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE)

    if (approveNewVersion == '1')
      this.isApproveVersions = true
    else
      this.isApproveVersions = false


  }
  onAccessibleChange(newValue) {
    this.clearErrorMsg()
    this.accessibleindex = this.accessible.findIndex(item => item.displayname === newValue.value.displayname);
  }
  onDownloadChange(newValue) {
    this.clearErrorMsg()
    this.downloadindex = this.downloadrights.findIndex(item => item.displayname === newValue.value.displayname);
  }

  onLinkChange(newValue) {
    this.clearErrorMsg()
    this.linkindex = this.linkexpires.findIndex(item => item.displayname === newValue.value.displayname);
  }

  onToggleWaterMark(value) {
    this.clearErrorMsg()
    this.isWaterMark = value.checked;
  }

  onToggleApproveVersion(value) {
    this.clearErrorMsg()
    this.isApproveVersions = value.checked;
  }

  onToggleNotify(value) {
    this.clearErrorMsg()
    this.notifyEditdownload = value.checked;
  }

  closeDialog() {
    this.sharedSer.isShare$.next(false)
    this.sharedSer.updateShareData$.next(null)
  }
  public getFileIcon() {
    return new Utils().getFileIcon(this.type);
  }
  shareItem() {
    this.clearErrorMsg()
    var date = new Date();
    var utils = new Utils();
    var numberOfDaysToAdd = this.linkexpires[this.linkindex].alias;
    var fomatteddate;
    if (numberOfDaysToAdd != "0") {
      date.setDate(date.getDate() + Number(numberOfDaysToAdd));
      fomatteddate = utils.getEncryptedHeaderString(utils.getUtcTicks(date.getTime()).toString());
    }
    else {
      fomatteddate = utils.getEncryptedHeaderString('NEVER');//Constants.EXPIRY_DATE_TEXT;
    }
    this.share.expiry = fomatteddate//set Expiry date based on link expires settings

    //Based on settings of download rights//{1(download_view_print) / 2(view_only) / 3(edit_download_view_print)}
    this.share.permissions = Number(this.downloadindex + 1);
    //Based on settings of Accessible by {1(anyone) / 2(my organisation user) / 3(system users)/ 4(Can be accessed by anyone who has the password) this 4th option is introduced from api version 6 onwards for sharing password protected files}.
    this.share.shareoption = Number(this.accessibleindex + 1);

    if (this.share.permissions === 2)
      this.share.applywatermark = Number(this.isWaterMark ? 1 : 0);//{0/1}Based on settings of Apply watermark
    if (this.share.permissions === 3)
      this.share.approvenewversions = Number(this.isApproveVersions ? 1 : 0);//{0/1}Based on settings of Approve new versions {0(approve edits is not required) / 1(approve edits by recipients before they are committed as new versions)} this option is introduced from api version 12 when permission value is 3.

    this.share.resourceid = Number(this.id);
    this.share.resourcetype = this.types; //{folder/file}. 
    this.share.notification = Number(this.notifyEditdownload ? 1 : 0);//{0/1}Based on settings of Notify me
    if (this.share.shareoption === 4) {
      this.share.pwrd = utils.getEncryptedHeaderString(this.password);//Based on settings of accessible by if it's Anyone with password then password will come here
    }

    var fileFolderobj = {
      filefoldername: this.name,
      types: this.types,
      fileType: this.type,
      contentId: this.id,
      locations: this.location,
      fileSize: this.size,
      lastmodified: this.lastmodified,
    }
    this.sharebutton.sharetitle = Constants.GENERATING_LINK
    this.sharebutton.isDisabled = true;
    this.shareUtils.generateSharedLink(this.apiService, this.share, this.dialogRef, new Utils(), this.dialog, fileFolderobj, this.shareUtils, this.sharedSer, this.errorMsg, this.sharebutton)
  }
}
